import { render } from "./ToggleSwitch.vue?vue&type=template&id=03decf08"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=03decf08&lang=scss"
script.render = render

export default script